/**
 * @file コンポーネント：フル動画ページタイムライントピックコメント DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル設定読み込み
import {
    StyledComment,
    StyledCommentBody,
    StyledCommentBodyText,
    StyledCommentBodyUsername,
    StyledCommentTime,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledComment>
            {/* コメント時間 */}
            <StyledCommentTime>{props.time}</StyledCommentTime>
            {/* サムネイル */}
            {props.thumbnail && (
                <img
                    src={props.thumbnail.src}
                    style={props.thumbnail.style}
                    alt="thumbnail"
                />
            )}
            <StyledCommentBody
                className={
                    (props.userId === null ||
                        props.userId !== props.mainSurgeonId) &&
                    "is-other"
                }
                data-initial={props.userInitial}
            >
                {/* コメントユーザー名 */}
                <StyledCommentBodyUsername>
                    {props.userName}
                </StyledCommentBodyUsername>
                {/* コメント本文 */}
                <StyledCommentBodyText ref={props.refText}>
                    {props.text}
                </StyledCommentBodyText>
            </StyledCommentBody>
        </StyledComment>
    );
};
